import { prefetchPage, prefetchShowroomVisit, prefetchTranslation } from '@Navigation/prefetchers';

import type { LoaderFn } from '@Types/Router';

export const loader: LoaderFn = (query) => async (args) => {
  const { queryClient } = query;
  const { request, params } = args;
  const { page } = params;

  return Promise.all([
    prefetchPage(request.url, queryClient),
    prefetchTranslation(request.url, queryClient),
    prefetchShowroomVisit(page, queryClient),
  ]);
};
